import { WarningOutlined } from '@ant-design/icons';

export const FakeDataComponent = () => {
  return (
    <span style={{ color: 'red' }}>
      {'Нет данных' + ' '}
      <WarningOutlined />
    </span>
  );
};
